import React from "react";

const Header = () => {
    return (
        <div className="">
            <h2 className="ui header app-header">
                <img src="/favicon/android-chrome-192x192.png" alt="timeZapp" width="24" />
                <div className="content">TimeZapp</div>
            </h2>
        </div>
    );
};

export default Header;
